<template>
<!--  pl-4 -->
  <a :href="navItem.href"
     :class="[navItem.current ? 'bg-gray-200 text-gray-900' : 'text-gray-900 hover:bg-gray-50', 'group flex items-center  pr-1 py-2 mb-2 font-medium rounded-md focus:outline-none  border-2 border-transparent focus:border-transparent']"
     :aria-current="navItem.current ? 'page' : undefined"
  >
<!--  -ml-1  -->
    <component :is="navItem.icon"
               :class="[navItem.current ? 'text-gray-900' : 'text-gray-900 group-hover:text-gray-900 ', 'flex-shrink-0  mr-3 h-5 w-5']"
               aria-hidden="true"
    />
    <span class="truncate flex-1">
      {{ navItem.name }}
    </span>
    <span v-if="navItem.count"
          :class="[navItem.current ? 'bg-white' : 'bg-gray-10 group-hover:bg-gray-20', 'ml-3 inline-block py-0.5 px-3 text-xs font-medium rounded-full']"
    >
      {{ navItem.count }}
    </span>
  </a>
</template>

<script>
export default {
  name: "ItemNav",
  props: ["navItem"]
}
</script>
